import Input from '../ui/Input';
import Select from '../ui/Select';

/**
 * Renders a single user-defined dynamic field — used by workflow steps (the /workflow
 * "Edit step" modal) and nationality masters (the Nationalities master page).
 * `value`/`onChange` speak the raw answer shape: a string for text/number/date/radio/select,
 * an array for checkbox/multiselect.
 */
export default function DynamicField({ field, value, onChange }) {
  if (field.type === 'text') {
    return <Input value={value || ''} onChange={(e) => onChange(e.target.value)} />;
  }

  if (field.type === 'number') {
    return <Input type="number" value={value ?? ''} onChange={(e) => onChange(e.target.value)} />;
  }

  if (field.type === 'date') {
    return <Input type="date" value={value || ''} onChange={(e) => onChange(e.target.value)} />;
  }

  const options = field.options || [];

  if (field.type === 'radio') {
    return (
      <div className="space-y-1">
        {options.map((opt) => (
          <label key={opt} className="flex items-center gap-2 text-sm text-gray-700">
            <input type="radio" name={field.id} checked={value === opt} onChange={() => onChange(opt)} />
            {opt}
          </label>
        ))}
      </div>
    );
  }

  if (field.type === 'select') {
    return (
      <Select value={value || ''} onChange={(e) => onChange(e.target.value)}>
        <option value="">Select…</option>
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </Select>
    );
  }

  const selected = value || [];
  const toggle = (opt, checked) => onChange(checked ? selected.filter((o) => o !== opt) : [...selected, opt]);

  if (field.type === 'checkbox') {
    return (
      <div className="space-y-1">
        {options.map((opt) => (
          <label key={opt} className="flex items-center gap-2 text-sm text-gray-700">
            <input type="checkbox" checked={selected.includes(opt)} onChange={() => toggle(opt, selected.includes(opt))} />
            {opt}
          </label>
        ))}
      </div>
    );
  }

  // multiselect
  return (
    <Select multiple value={selected} onChange={(e) => onChange(Array.from(e.target.selectedOptions, (o) => o.value))} className="h-auto">
      {options.map((opt) => (
        <option key={opt} value={opt}>
          {opt}
        </option>
      ))}
    </Select>
  );
}
